import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Inject, Input, OnDestroy, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { KENDO_APPBAR } from '@progress/kendo-angular-navigation';
import { KENDO_SVGICON } from '@progress/kendo-angular-icons';
import { arrowRotateCwSmallIcon, logoutIcon, menuIcon, paperclipIcon, plusIcon, uploadIcon, userIcon, userOutlineIcon } from "@progress/kendo-svg-icons";
import { KENDO_BUTTON, KENDO_SPLITBUTTON } from '@progress/kendo-angular-buttons';
import { Router, RouterLink } from '@angular/router';
import { MSAL_GUARD_CONFIG, MsalBroadcastService, MsalGuardConfiguration, MsalService } from '@azure/msal-angular';
import { AccountInfo, InteractionStatus, RedirectRequest } from '@azure/msal-browser';
import { filter, Subject, takeUntil } from 'rxjs';
import { SwitchModule } from '@progress/kendo-angular-inputs';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { HeaderService } from '../../_services/header.service';
import { emptyHeaderToggleI, HeaderToggleI } from '../../_models/header_objects';
import { constants } from '../../../environments/constants';
import { PortalLogService } from '../../_services/portal-log.service';


@Component({
    selector: 'app-header',
    imports: [KENDO_APPBAR, KENDO_SVGICON, KENDO_BUTTON, KENDO_SPLITBUTTON, RouterLink, SwitchModule, FormsModule, FormsModule, CommonModule],
    templateUrl: './header.component.html',
    styleUrl: './header.component.css',
    changeDetection: ChangeDetectionStrategy.OnPush
})

export class HeaderComponent implements OnInit, OnDestroy {
  @Output() drawerClickEvent = new EventEmitter<boolean>();
  @Output() iconClicked = new EventEmitter<string>();
  @Output() refreshClicked = new EventEmitter<string>();
  @Input() parentUserData: HeaderToggleI = emptyHeaderToggleI();
  @Input() url: string = '';
  userType = false;
  version = constants.version;
  userTypeData: HeaderToggleI = emptyHeaderToggleI();
  public icons = { paperclip: paperclipIcon, menuIcon: menuIcon, plusIcon: plusIcon, refreshIcon: arrowRotateCwSmallIcon, login: userOutlineIcon, logout: logoutIcon, upload: uploadIcon, profileUser: userIcon };
  private readonly _destroying$ = new Subject<void>();
  show: boolean = true;

  headerStyle = {
    'background-color': constants.headerBackgroundColor
  };

  public signedInButtonData = [
    {
      text: "Profile",
      svgIcon: this.icons.profileUser,
      click: (): void => {
        this.goToProfile();
      },
    },
    {
      text: "Logout",
      svgIcon: this.icons.logout,
      click: (): void => {
        this.logout();
      },
    }]

  loginDisplay = false;
  constructor(private router: Router
    , @Inject(MSAL_GUARD_CONFIG) private msalGuardConfig: MsalGuardConfiguration,
    private authService: MsalService,
    private msalBroadcastService: MsalBroadcastService, private service: HeaderService, private cdr: ChangeDetectorRef, private portalLogService: PortalLogService
  ) {

  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['parentUserData'], changes['parentUserData']?.currentValue) {
      this.userTypeData = this.parentUserData;
      this.fetchToggle();
    }
  }
  ngOnInit(): void {
    this.msalBroadcastService.inProgress$
      .pipe(
        filter((status: InteractionStatus) => status === InteractionStatus.None),
        takeUntil(this._destroying$)
      )
      .subscribe(() => {
        this.setLoginDisplay();
        this.checkAndSetActiveAccount();
      });
  }

  ngOnDestroy(): void {
    this._destroying$.next(undefined);
    this._destroying$.complete();
  }
  fetchToggle() {
    //this.service.fetchToggle().subscribe(res => {
    this.userTypeData = this.parentUserData;
    this.userTypeData?.usertype == 'A' ? this.userType = true : this.userType = false;
    this.cdr.markForCheck();
    // });
  }
  setToggle() {
    this.userTypeData.usertype == 'A' ? this.userTypeData.usertype = 'E' : this.userTypeData.usertype = 'A';
    this.service.setToggle(this.userTypeData).subscribe(res => {
      sessionStorage.setItem('userData', JSON.stringify(this.userTypeData));
      location.reload();
    });

  }
  logout() {
    this.portalLogService.addLogOutActivity().subscribe(res => {
      this.authService.logoutRedirect();
      sessionStorage.clear();
      return;
    });

  }

  refreshCurrentTab(str: string) {
   this.refreshClicked.emit(str);
  }
  navigate(str: string) {
    this.iconClicked.emit(str);
  }
  drawerAction(event: any) {
    this.drawerClickEvent.emit(true);
  }

  public newUpload(): void {
    this.router.navigate(['/upload']);
  }

  setLoginDisplay() {
    this.loginDisplay = this.authService.instance.getAllAccounts().length > 0;
  }
  loginRedirect() {
    if (this.msalGuardConfig.authRequest) {
      this.authService.loginRedirect({ ...this.msalGuardConfig.authRequest } as RedirectRequest);
    } else {
      this.authService.loginRedirect();
    }
  }
  activeAccount: AccountInfo | null = null;
  checkAndSetActiveAccount() {
    /**
     * If no active account set but there are accounts signed in, sets first account to active account
     * To use active account set here, subscribe to inProgress$ first in your component
     * Note: Basic usage demonstrated. Your app may require more complicated account selection logic
     */
    this.activeAccount = this.authService.instance.getActiveAccount();
    console.log("this.activeAccount", this.activeAccount);
    if (!this.activeAccount && this.authService.instance.getAllAccounts().length > 0) {
      let accounts = this.authService.instance.getAllAccounts();
      this.authService.instance.setActiveAccount(accounts[0]);
    }
  }

  goToProfile() {
    throw new Error('Method not implemented.');
  }
  signedInUser() {
    if (this.activeAccount != null) {
      return this.activeAccount.name;
    } else {
      return "";
    }
  }

  splitButtonClick(click: any) {
    console.log(click)
  }
  getEmailConfirmation() {
    const emails = [
      'thaaijer@mcdermott.com',
      'jeremy.wier@mcdermott.com',
      'anamika.singh@mcdermott.com',
      'x.mike.koshel@mcdermott.com',
      'kranade@mcdermott.com',
      'varsha.ghadge@mcdermott.com',
      'pratik.sawant@mcdermott.com',
      'lois.jaynes@mcdermott.com',
      'ctoet@mcdermott.com',
      'amber.blasko@mcdermott.com'
    ];

    const usernameIncludesEmail = emails.some(email =>
      this.userTypeData?.email?.toLowerCase().includes(email)
    );
    console.log("usernameIncludesEmail", usernameIncludesEmail);
    if (usernameIncludesEmail) {
      return true;
    } else {
      return false;
    }
  }
}
